import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { Message as IMessage } from "../../../../types";

const Message = ({
    value
}: {
    value: IMessage
}) => {

    const labelWidth = useMemo(() => 80, []);

    return (
        <Card variant="outlined">
            <CardContent>
                <Stack rowGap={2}>
                    <Box>
                        <Typography variant="body2">{value.user}</Typography>
                        <Typography variant="caption">{value.timestamp}</Typography>
                    </Box>
                    <Box>
                        <Stack direction="row" alignItems="center">
                            <Typography variant="bodySmall" width={labelWidth}>To:</Typography>
                            <Typography variant="bodySmall">
                                {value.recipients
                                    .map((r, i, arr) => i === arr.length - 1 ? r.label : `${r.label}; `)
                                }
                            </Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center">
                            <Typography variant="bodySmall" width={labelWidth}>Subject:</Typography>
                            <Typography variant="bodySmall">{value.subject}</Typography>
                        </Stack>
                    </Box>
                    <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                        {value.body}
                    </Typography>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default Message;
